import React from 'react';
import { Select } from 'antd';
import { useQuery } from '@common/hooks';
import { ErrorHandler, LoadingState, Form } from '@common/components';
import { ClinicalSpecialtiesQuery } from '@institutions/graphql';
import { selectInputFilterHelper } from '@common/services';

export const SpecialtySelect = ({
  disabled = false,
  required = true,
  label = 'Specialty',
  multiple = false,
  formItemName = 'specialtyId',
  onSelect,
  onChange,
  placeholder = 'Select specialty',
  hidden = false,
  disabledOptions = [],
}: {
  disabled?: boolean;
  required?: boolean;
  label?: string;
  multiple?: boolean;
  formItemName?: string;
  onSelect?: (value: string) => void;
  onChange?: (values: string[]) => void;
  placeholder?: string;
  hidden?: boolean;
  disabledOptions?: string[];
}) => {
  const { loading, error, data } = useQuery(ClinicalSpecialtiesQuery, {
    fetchPolicy: 'cache-first',
  });

  if (loading || !data) {
    return <LoadingState />;
  }

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="SpecialtySelect"
        messageType="contextual"
      />
    );
  }

  return (
    <Form.Item
      label={label}
      colon={false}
      name={formItemName}
      hidden={hidden}
      rules={[
        {
          required: required,
          message: 'Please select an specialty',
        },
      ]}
    >
      <Select
        mode={multiple ? 'multiple' : undefined}
        allowClear={multiple}
        disabled={disabled}
        filterOption={selectInputFilterHelper}
        onSelect={onSelect}
        onChange={onChange}
        showSearch
        size="large"
        placeholder={placeholder}
        getPopupContainer={(trigger) => trigger.parentNode}
      >
        {data.clinicalSpecialties.map(({ id, displayName }) => {
          return (
            <Select.Option
              key={id}
              value={id}
              disabled={disabledOptions.includes(id)}
            >
              {displayName}
            </Select.Option>
          );
        })}
      </Select>
    </Form.Item>
  );
};
